import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { FlexibleCalculationPage } from '@/areas/flexible-calculations/FlexibleCalculation/FlexibleCalculationPage';
import { canViewFlexibleCalculation } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/flexible-calculation/')({
    staticData: { access: { permissions: canViewFlexibleCalculation }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ summaryId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const summaryId = Route.useSearch({ select: (search) => search.summaryId });
    return <FlexibleCalculationPage {...pathParams} flexibleCalculationId={undefined} summaryId={summaryId} />;
}
